"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var StatusAlertFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z M12.7287834,7.27532214 C12.5372325,7.08377129 12.2723557,6.98417081 12.0020527,7.00205275 C11.7317498,6.98417081 11.466873,7.08377129 11.2753221,7.27532214 C11.0837713,7.46687299 10.9841708,7.73174979 11.0020527,8.00205275 L11.0020527,12.0020527 C10.9841708,12.2723557 11.0837713,12.5372325 11.2753221,12.7287834 C11.466873,12.9203342 11.7317498,13.0199347 12.0020527,13.0020527 C12.2723557,13.0199347 12.5372325,12.9203342 12.7287834,12.7287834 C12.9203342,12.5372325 13.0199347,12.2723557 13.0020527,12.0020527 L13.0020527,8.00205275 C13.0199347,7.73174979 12.9203342,7.46687299 12.7287834,7.27532214 Z M12.7287834,15.2753221 C12.5372325,15.0837713 12.2723557,14.9841708 12.0020527,15.0020527 C11.7317498,14.9841708 11.466873,15.0837713 11.2753221,15.2753221 C11.0837713,15.466873 10.9841708,15.7317498 11.0020527,16.0020527 C10.9841708,16.2723557 11.0837713,16.5372325 11.2753221,16.7287834 C11.466873,16.9203342 11.7317498,17.0199347 12.0020527,17.0020527 C12.2723557,17.0199347 12.5372325,16.9203342 12.7287834,16.7287834 C12.9203342,16.5372325 13.0199347,16.2723557 13.0020527,16.0020527 C13.0199347,15.7317498 12.9203342,15.466873 12.7287834,15.2753221 Z" })));
};
StatusAlertFilled.displayName = 'StatusAlertFilled';
exports.default = StatusAlertFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=StatusAlertFilled.js.map